// components/Shared/LoadingSpinner.jsx
import React from 'react';
import { Spin } from 'antd';

const LoadingSpinner = ({ message = "Cargando..." }) => (
  <div style={styles.spinnerContainer}>
    <Spin size="large" />
    {message && <p style={styles.text}>{message}</p>}
  </div>
);

const styles = {
  spinnerContainer: {
    width: '100%',
    textAlign: 'center',
    padding: '40px 0',
  },
  text: {
    marginTop: '10px',
    fontSize: '16px',
    color: '#555',
  },
};

export default LoadingSpinner;
